module.exports = __webpack_public_path__ + "img/logo.34bb388d.png";